import { MenuItem } from "@material-ui/core";
import React from "react";

// Planos que, por enquanto, se comportam exatamente como o Essencial.
// O "2026" (novo modelo de vendas, 22/09/2026) nasceu assim e será
// diferenciado depois — espelha SalesScope::PLANOS_COMO_ESSENCIAL na API.
// O "Análise" (22/10/2026) entra aqui porque o cliente também apostila
// por conta própria e paga as custas da emissão.
export const PLANOS_COMO_ESSENCIAL = ["ESSENTIAL", "PLAN_2026", "PLAN_ANALISE"];

// Plano Análise: o cliente contrata só a análise documental (documentos
// digitais pela Central do Cliente, laudo em 7 dias). Sem procuração,
// sem envio e sem despacho nesta venda.
export const PLAN_ANALISE = "PLAN_ANALISE";

export const isPlanoAnalise = familyPlan => familyPlan === PLAN_ANALISE;

export const isLegacyFamilyPlan = familyPlan => {
  const newPlans = ["ESSENTIAL", "PLAN_2026", "PLAN_ANALISE", "PREMIUM", "EXCLUSIVE"];

  if (!familyPlan) {
    return false;
  }

  return !newPlans.includes(familyPlan);
};

export const isEssentialPlan = familyPlan => {
  if (!familyPlan) return false;

  return PLANOS_COMO_ESSENCIAL.includes(familyPlan);
};

export const getFamilyPlanOptions = (scope, filterProcessesNoCourtesy) => {
  const items = [];


    if (filterProcessesNoCourtesy.length > 0) {
      items.push(
        <MenuItem value="NONE" key="NONE">
          Plano Cidadão
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 3) {
      items.push(
        <MenuItem
          value="INITIAL_PORTUGUESE_FAMILY"
          key="INITIAL_PORTUGUESE_FAMILY"
        >
          Plano Origens
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 5) {
      items.push(
        <MenuItem value="SMALL_PORTUGUESE_FAMILY" key="SMALL_PORTUGUESE_FAMILY">
          Plano Sucessões
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 8) {
      items.push(
        <MenuItem value="BIG_PORTUGUESE_FAMILY" key="BIG_PORTUGUESE_FAMILY">
          Plano Gerações
        </MenuItem>
      );
    }

  items.push(
    <MenuItem value="ESSENTIAL" key="ESSENTIAL">
      Essencial
    </MenuItem>
  );

  // Plano "2026": escondido em producao ate as mudancas subsequentes
  // (contrato e perguntas proprias) estarem prontas. A opcao segue
  // visivel em staging (branch develop) para validacao.
  if (process.env.REACT_APP_PLANO_2026 === "1") {
    items.push(
      <MenuItem value="PLAN_2026" key="PLAN_2026">
        2026
      </MenuItem>
    );
  }

  // Plano "Análise" (22/10/2026): mesmo padrão do 2026 — visível em
  // staging (develop) para validação; em produção só quando o founder
  // liberar (REACT_APP_PLANO_ANALISE no build de master).
  if (process.env.REACT_APP_PLANO_ANALISE === "1") {
    items.push(
      <MenuItem value={PLAN_ANALISE} key={PLAN_ANALISE}>
        Análise
      </MenuItem>
    );
  }

  items.push(
    <MenuItem value="PREMIUM" key="PREMIUM">
      Premium
    </MenuItem>
  );

  items.push(
    <MenuItem value="EXCLUSIVE" key="EXCLUSIVE">
      Exclusivo
    </MenuItem>
  );

  return items;
};

export const filterProcessesApensados = processes => {
  if (!Array.isArray(processes) || processes.length === 0) {
    return [];
  }

  return processes.filter(process => Boolean(process.apensado));
};
